module.exports = __webpack_public_path__ + "static/media/AutoCAD LT for Mac.bd5cef88.png";